import { useEffect, useState } from 'react';

/**
 * Valor con retardo: se actualiza `delayMs` después del último cambio. Para
 * búsquedas mientras se escribe (evita un query por tecla).
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
